<div class="filter-bottomsheet-container">
  <div
    class="filter-bottomsheet-wrapper"
    [style.min-height]="isAutoHeight && 'auto'"
  >
    <ng-content></ng-content>
  </div>
</div>
